(ns portal.forgot-password-page.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            [common.widgets.auth-card :refer [auth-card]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.page :as page]
            [portal.forgot-password-page.db :as form]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(defui forgot-password-page []
  (let [{:keys [status email]} (use-subscribe [:form.forgot-password/state])
        reset-token-expired? (use-subscribe [:form.forgot-password/reset-token-expired?])]
    (uix/use-effect (fn []
                      (rf/dispatch [:form.forgot-password/init]))
                    [])
    ($ page/page {:sidebar false
                  :appbar false}
       ($ page/content-padding
          (when reset-token-expired?
            ($ Alert
               {:severity "warning"
                :sx #js {:position "absolute"
                         :top 0
                         :left 0
                         :width "100%"}}
               "The password reset URL has expired, please fill in your email address to request a new URL."))
          ($ auth-card {:on-submit #(rf/dispatch [:form.forgot-password/submit])}
             ($ form-field
                {:label "Request a password email"
                 :err-msg (form/use-error-message [:email])
                 :data-testid "forgot-password-email"}
                ($ input (form/use-bind-control [:email])))
             (when (= status :success)
               ($ Alert
                  {:severity "success"
                   :data-testid "success-alert"}
                  (str "A reset password email has been sent to " email)))
             ($ Button
                {:variant "contained"
                 :type "submit"
                 :data-testid "request-email-button"}
                "Request Email")
             ($ Button
                {:href (r.easy/href :common/login)
                 :data-testid "back-to-login"}
                "← Go back to login page"))))))
